/**
 * Created by rathompson on 5/26/22
 * File: ContractRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useCallback, useMemo } from 'react'
import { Button, Link, Tooltip } from '@panwds/react-ui'
import { HelpInPageIcon } from '@panwds/icons'
import { LABEL_NOT_APPLICABLE, TOOLTIP_VIEW_SUPPORT } from '../../../constants/LabelConstants'
import { useSupportInfoModule } from '../Modal/SupportInfoModal'
import { BUNDLED_PRODUCTS } from '../../../../common/constants/LabelConstants'
import { isNonemptyArray } from '../../../../hub/utils/common'

const ContractRenderer = ({ row = {}, value }) => {
  const { openModal: openInfoModal } = useSupportInfoModule(row?.original || {})
  const onClick = useCallback(() => openInfoModal(), [openInfoModal])
  const labels = useMemo(() => {
    const instance = row?.original || {}
    const { contract } = instance
    const serial_numbers = (BUNDLED_PRODUCTS.has(instance?.app_id) && instance?.entitlements?.length > 1) ? instance?.entitlements?.map(e => e.serial_number) : instance?.serial_number ? [instance?.serial_number] : null
    return contract || serial_numbers || LABEL_NOT_APPLICABLE
  }, [row?.original])

  const Contract = ({ label }) => (<Tooltip label={TOOLTIP_VIEW_SUPPORT}>
    <div className='tw-flex tw-items-center tw-gap-0.5' onClick={onClick}>
      <Link>{label}</Link>
      <Button
        aria-label='contract-button'
        icon={<HelpInPageIcon size='sm' />}
        appearance='clear'
        style={{ background: 'transparent', height: '1rem', padding: 0 }}
      />
    </div>
  </Tooltip>
  )
  return <div className='cm-h-full cm-w-full cm-py-2'>
    {isNonemptyArray(labels) ?
      labels.map((each, index) => (<Contract key={index} label={each}></Contract>)) :
      labels?.trim().length > 0 ? <Contract label={labels}></Contract> : <></>
    }
  </div>
}

ContractRenderer.propTypes = {}
export default ContractRenderer
